<template>
  <div class="title-page-view">
    <div class="title-content">
      <h2>{{titleObj.mainHeading}}</h2>
      <h3>{{titleObj.subhead}}</h3>
      <div><p></p></div>
      <p class="title">{{titleObj.content}}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {}
    },
    props:{
      titleObj:Object
    },
    methods:{},
    mounted(){}
  }
</script>
<style lang="scss" rel="stylesheet" scoped="">
  .title-page-view{
    padding:0.3rem;
    .title-content{
      h2{
        color:#555555;
        font-size:0.34rem;
      }
      h3{
        color:#555555;
        font-size:0.3rem;
      }
      div{
        width:1.9rem;
        height:1px;
        background:#d5d5d5;
        margin:0.1rem auto;
        p{
          width:0.5rem;
          height: 2px;
          background:#ffbd1f;
          margin:auto;
          position: relative;
          top:-1px;
        }
      }
      .title{
        color:#555555;
        font-size:0.16rem;
      }
    }
  }
</style>
